import { IpcMessage } from '@flowus/shared';
import { getOnlineVersion } from './hooks/public/use-version';
import { ipcSendMessage, isFlowUsApp } from './utils/electron-util';

if (isFlowUsApp.check) {
  const checkVersion = async () => {
    const versionRes = await getOnlineVersion();
    const forceClearLocalAndReloadIds = versionRes?.forceClearLocalAndReloadIds ?? [];
    const isReload = forceClearLocalAndReloadIds.includes(__VERSION__);
    if (isReload) {
      ipcSendMessage(IpcMessage.ClearCacheAndReload);
    }
  };

  const setup = () => {
    void checkVersion();
  };

  setup();
}
